import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import PercentIcon from "@mui/icons-material/Percent";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useFormik } from "formik";
import dayjs from "dayjs";
import { LoadingButton } from "@mui/lab";
import { enqueueSnackbar } from "notistack";
import CustomInput from "src/components/customerinput/CustomerInput";
import { eventDiscount } from "src/schemas";
import { useAuthContext } from "src/auth/useAuthContext";
import { handleKeyPress } from "src/functions";
import { notify } from "src/components/notify";
import { CoinIcon } from "src/svgs";
import getEventsDiscountDetails from "src/services/events/getDiscountDetails";
import updateDiscountDetails from "src/services/events/putDiscount";
import CustomModal from "src/components/customerinput/CustomModal";

export default function EditDiscountModal({
  close,
  open,
  eventData,
  selectedItem,
  setDiscountData,
}) {
  const { user, logout } = useAuthContext();
  const [isloading, setIsloading] = useState(false);
  const [code, setCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const {
    handleChange,
    handleSubmit,
    values,
    handleBlur,
    setFieldValue,
    errors,
    touched,
    setValues,
  } = useFormik({
    initialValues: {
      coupon_name: "",
      valid_till: dayjs(eventData?.distribution_end),
      is_discount_visible: "true",
      couponId: "",
    },
    validationSchema: eventDiscount,
    onSubmit: async (value) => {
      try {
        if (!value.valid_from || !value?.valid_till) {
          notify("Date is required.");
          return;
        }

        if (
          values?.multi_limit === "true" &&
          values?.multi_use < values?.usage_limit
        ) {
          notify("Multi-use limit   less than usage limit.");
          return;
        }

        if (values?.multi_use === "" && values?.multi_limit == "true") {
          notify("Enter Discount Usage Limit Per Customer");
          return;
        }

        setIsloading(true);
        let newValues = {
          coupon_name: value?.coupon_name,
          couponId: value?.couponId,
          is_discount_visible:
            value.is_discount_visible == "false" ? false : true,
          valid_till: dayjs(value?.valid_till).format(),
          description: value?.description,
          min_amount: value?.min_amount,
          multi_use: value?.multi_use,
          usage_limit: value?.usage_limit,
        };

        const { data } = await updateDiscountDetails(user, newValues, logout);

        if (data) {
          setDiscountData((prev) => {
            const updatedCouponData =
              prev?.filter((coupon) => coupon._id !== data._id) || [];
            const findCouponData = prev?.find(
              (coupon) => coupon._id == data._id
            );

            return [
              ...updatedCouponData,
              { ...data, tickets: findCouponData?.tickets },
            ];
          });
          notify("Discount coupon updated.", "success");
          close();
        }
      } catch (err) {
        enqueueSnackbar(err?.data?.message || error?.data, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      } finally {
        setIsloading(false);
      }
    },
  });

  useEffect(() => {
    const fetch = async () => {
      try {
        setIsLoading(true);
        const {
          data: { coupon },
        } = await getEventsDiscountDetails(user, selectedItem, logout);
        const {
          name,
          description,
          coupon_handle,
          valid_from,
          valid_till,
          event,
          is_points,
          percentage,
          max_amount,
          min_amount,
          multi_use,
          usage_limit,
          is_discount_visible,
          _id,
        } = coupon;
        setValues({
          coupon_name: name,
          valid_from: dayjs(valid_from),
          valid_till: dayjs(valid_till),
          usage_limit: usage_limit,
          percentage: percentage,
          event: event,
          is_discount_visible: String(is_discount_visible),
          code: coupon_handle,
          is_points: is_points,
          multi_limit: "false",
          multi_use: multi_use,
          description: description,
          min_limit: "false",
          max_limit: "false",
          min_amount: min_amount,
          max_amount: max_amount,
          couponId: _id,
        });
        setCode(coupon_handle);
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetch();
  }, [selectedItem]);
  useEffect(() => {
    setFieldValue("event", eventData?._id);
  }, [open]);
  console.log(values);

  return (
    <CustomModal
      heading="Update Ticket Discount"
      open={open}
      close={close}
      action={
        <LoadingButton
          variant="contained"
          form="discount"
          loading={isloading}
          disabled={isloading}
          type="form"
        >
          update
        </LoadingButton>
      }
    >
      <form id="discount" onSubmit={handleSubmit}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <CustomInput
              label="Discount Name"
              required
              input={
                <TextField
                  fullWidth
                  name="coupon_name"
                  value={values?.coupon_name || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Discount Name"
                  helperText={
                    errors?.coupon_name && touched.coupon_name
                      ? errors?.coupon_name
                      : null
                  }
                  inputProps={{ maxLength: 25 }}
                  error={
                    errors?.coupon_name && touched.coupon_name ? true : false
                  }
                />
              }
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              label="Discount Description (Optional)"
              input={
                <TextField
                  fullWidth
                  name="description"
                  value={values?.description || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Discount Description"
                  helperText={
                    errors?.description && touched.description
                      ? errors?.description
                      : null
                  }
                  error={
                    errors?.description && touched.description ? true : false
                  }
                />
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid lightGrey",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "8px",
              }}
            >
              <Typography variant="subtitle2">Discount Code</Typography>

              <CustomInput
                input={
                  <TextField
                    fullWidth
                    name="description"
                    value={values?.code || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Discount Description"
                    disabled
                  />
                }
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid lightGrey",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "8px",
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <CustomInput
                    required
                    label="Discount Value"
                    helperText={
                      errors?.percentage && touched.percentage
                        ? errors?.percentage
                        : null
                    }
                    helperColor="red"
                    input={
                      <OutlinedInput
                        fullWidth
                        disabled
                        helperText={
                          errors?.percentage && touched.percentage
                            ? errors?.percentage
                            : null
                        }
                        error={
                          errors?.percentage && touched.percentage
                            ? true
                            : false
                        }
                        inputProps={{
                          maxLength: values?.is_points == "false" ? 3 : 6,
                        }}
                        name="percentage"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyPress}
                        value={values?.percentage}
                        placeholder="Max Bookings Can be taken"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              {values?.is_points == "false" ? (
                                <PercentIcon color="primary" />
                              ) : (
                                <CoinIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid lightGrey",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "8px",
              }}
            >
              <Typography variant="subtitle2">Minimum Ticket Value</Typography>
              <CustomInput
                input={
                  <TextField
                    fullWidth
                    name="min_amount"
                    value={values?.min_amount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter Discount min_amount"
                  />
                }
              />
            </Box>
          </Grid>

          {values?.is_points == "false" && (
            <Grid item xs={12}>
              <Box
                sx={{
                  border: "1px solid lightGrey",
                  borderRadius: "8px",
                  padding: "10px",
                  marginTop: "8px",
                }}
              >
                <Typography variant="subtitle2">
                  Maximum Discount Amount
                </Typography>
                <CustomInput
                  input={
                    <TextField
                      fullWidth
                      name="max_amount"
                      value={values?.max_amount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter Discount max_amount"
                      disabled
                    />
                  }
                />
              </Box>
            </Grid>
          )}

          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid lightGrey",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "8px",
              }}
            >
              <Typography variant="subtitle2">
                Discount Usage Limit Per Customer
              </Typography>
              <CustomInput
                input={
                  <TextField
                    fullWidth
                    name="multi_use"
                    value={values?.multi_use}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (value === "" || parseInt(value, 10) >= 1) {
                        handleChange(e);
                      }
                    }}
                    onBlur={handleBlur}
                    placeholder="Enter Discount multi_use"
                    inputProps={{ maxLength: 6 }}
                    type="number"
                    onWheel={(e) => e.target.blur()}
                  />
                }
              />
            </Box>
          </Grid>

          {/* Discount Visibility */}
          <Grid item xs={12}>
            <Box
              sx={{
                border: "1px solid lightGrey",
                borderRadius: "8px",
                padding: "10px",
                marginTop: "8px",
              }}
            >
              <Typography variant="subtitle2">Discount Visibility</Typography>
              <FormControl>
                <RadioGroup
                  sx={{ display: "flex", flexDirection: "row" }}
                  value={values?.is_discount_visible}
                  name="is_discount_visible"
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label="Visible on event page"
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label="Only to shared users"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Discount Usage Limit</Typography>
            <CustomInput
              input={
                <TextField
                  fullWidth
                  name="usage_limit"
                  value={values?.usage_limit}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Discount max_amount"
                />
              }
            />
          </Grid>
          <Grid item xs={6}>
            <CustomInput
              required
              label="Validity"
              input={
                <DateTimePicker
                  name="valid_from"
                  disablePast
                  minDate={dayjs(eventData?.distribution_start)}
                  maxDate={dayjs(eventData?.distribution_end)}
                  value={values?.valid_from || null}
                  minutesStep={1}
                  timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                  onChange={(e) => setFieldValue("valid_from", e)}
                  sx={{ width: "100%" }}
                  disabled
                />
              }
            />
          </Grid>
          <Grid item xs={6}>
            <CustomInput
              label={<p style={{ visibility: "hidden" }}>.</p>}
              input={
                <DateTimePicker
                  maxTime={
                    eventData?.slots ? null : dayjs(eventData?.distribution_end)
                  }
                  timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                  disablePast
                  value={values?.valid_till}
                  minDate={
                    values?.valid_from ? dayjs(values?.valid_from) : null
                  }
                  maxDate={
                    eventData?.slots ? null : dayjs(eventData?.distribution_end)
                  }
                  onChange={(e) => setFieldValue("valid_till", e)}
                  sx={{ width: "100%" }}
                />
              }
            />
          </Grid>
        </Grid>
      </form>
    </CustomModal>
  );
}
